/**
 * Feature-flag eligibility for the Settings nav item.
 * Show when Access Centre **or** AI Brand Tools **or** Customer Support is enabled (explicit `true` only — `undefined` while flags load is treated as off).
 *
 * TODO - in case any of the feature is nor dependent on the flag in the future we will have to make sure settings is enabled always in that case and no ton the other flags
 */
export const shouldShowSettingsNavForFlags = (
    accessCenterFlag: boolean | undefined,
    aiBrandToolsFlag: boolean | undefined,
    customerSupportFlag: boolean | undefined
): boolean => accessCenterFlag === true || aiBrandToolsFlag === true || customerSupportFlag === true;
